function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";

function Buttons(_ref) {
  var previous = _ref.previous,
      next = _ref.next;
  return React.createElement("div", {
    className: "recorder-frame-buttons"
  }, React.createElement("button", {
    className: "recorder__toolbar-option-icon-button",
    onClick: previous,
    disabled: !previous
  }, "<"), React.createElement("button", {
    className: "recorder__toolbar-option-icon-button",
    onClick: next,
    disabled: !next
  }, ">"));
}

var Frame = function (_React$Component) {
  _inherits(Frame, _React$Component);

  function Frame() {
    _classCallCheck(this, Frame);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Frame.prototype.calculateFrameContainerStyle = function calculateFrameContainerStyle() {
    var _props = this.props,
        active = _props.active,
        _props$frames = _props.frames,
        _props$frames$frames = _props$frames.frames,
        frames = _props$frames$frames === undefined ? [] : _props$frames$frames,
        _props$frames$selecte = _props$frames.selectedFrame,
        selectedFrameIndex = _props$frames$selecte === undefined ? 0 : _props$frames$selecte,
        videoWidth = _props.videoWidth,
        videoHeight = _props.videoHeight,
        containerWidth = _props.containerWidth,
        containerHeight = _props.containerHeight;

    if (!containerWidth || !active) {
      return {
        display: "none"
      };
    }

    var selectedFrame = frames[selectedFrameIndex];

    if (!selectedFrame) {
      return {
        display: "none"
      };
    }

    if (!videoWidth) {
      return {
        position: "absolute",
        top: 0,
        bottom: 60,
        //add bottom margin
        left: 0,
        right: 0,
        backgroundColor: "rgba(255, 255, 255, 0.5)",
        backgroundSize: "100% 100%",
        backgroundImage: "url(" + selectedFrame.url + ")"
      };
    }

    var scaleX = containerWidth / videoWidth;
    var scaleY = containerHeight / videoHeight;
    var scale = Math.min(scaleX, scaleY);
    var frameHeight = videoHeight * scale;
    var frameWidth = videoWidth * scale;
    var frameVerticalMargin = (containerHeight - frameHeight) / 2;
    var frameHorizontalMargin = (containerWidth - frameWidth) / 2;
    return {
      position: "absolute",
      backgroundSize: "100% 100%",
      backgroundImage: "url(" + selectedFrame.url + ")",
      top: frameVerticalMargin,
      bottom: frameVerticalMargin + 60,
      //add bottom margin
      left: frameHorizontalMargin,
      right: frameHorizontalMargin
    };
  };

  Frame.prototype.render = function render() {
    var _props2 = this.props,
        selectFrame = _props2.selectFrame,
        allowChange = _props2.allowChange,
        _props2$frames = _props2.frames,
        _props2$frames$frames = _props2$frames.frames,
        frames = _props2$frames$frames === undefined ? [] : _props2$frames$frames,
        _props2$frames$select = _props2$frames.selectedFrame,
        selectedFrameIndex = _props2$frames$select === undefined ? 0 : _props2$frames$select;
    return React.createElement("div", {
      className: "frame-container",
      style: this.calculateFrameContainerStyle()
    }, allowChange && React.createElement(Buttons, {
      previous: selectedFrameIndex === 0 ? null : function () {
        return selectFrame(selectedFrameIndex - 1);
      },
      next: selectedFrameIndex === frames.length - 1 ? null : function () {
        return selectFrame(selectedFrameIndex + 1);
      }
    }));
  };

  return Frame;
}(React.Component);

Frame.propTypes = process.env.NODE_ENV !== "production" ? {
  active: PropTypes.bool,
  allowChange: PropTypes.bool,
  frames: PropTypes.object,
  selectFrame: PropTypes.func,
  videoWidth: PropTypes.number,
  videoHeight: PropTypes.number,
  containerWidth: PropTypes.number,
  containerHeight: PropTypes.number
} : {};
export default Frame;